const Td = ({ children, className, style }) => {
  return (
    <td
      style={style}
      className={`bg-white text-gray-800 text-[16px] font-[400] leading-[35px] ${
        className ? className : ""
      }`}
    >
      {children}
    </td>
  );
};

export default Td;
